var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEvseBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_evse",
    "data-name": "icon - evse",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.999,
    height: 16.691,
    viewBox: "0 0 18.999 16.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_-_evse-2",
    "data-name": "icon - evse",
    d: "M-194-707.308h-4v-1.922h-2a2,2,0,0,1-2-2V-722a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v7.273h1a2.188,2.188,0,0,1,2.182,2.182v2.312a1.094,1.094,0,0,0,1.091,1.091,1.094,1.094,0,0,0,1.091-1.091V-715.5a2.783,2.783,0,0,1-1.091.229A2.728,2.728,0,0,1-188.455-718a2.718,2.718,0,0,1,1.756-2.542l-2.3-2.3,1.156-1.156,4.058,4.058-.011.011A2.729,2.729,0,0,1-183-718v7.767a2.728,2.728,0,0,1-2.727,2.728,2.728,2.728,0,0,1-2.727-2.728v-2.857H-190v1.859a2,2,0,0,1-2,2h-2v1.922Zm-4.4-8.161h1.528v3.437l3.055-5.347h-1.528v-3.82Zm11.58-2.531a1.094,1.094,0,0,0,1.091,1.091A1.094,1.094,0,0,0-184.637-718a1.094,1.094,0,0,0-1.091-1.091A1.094,1.094,0,0,0-186.818-718Z",
    transform: "translate(202 724)",
    fill: "#25556e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEvseBlue);
export default __webpack_public_path__ + "static/media/ic_evse_blue.487d92ab2dee20816650d9064d4c53f1.svg";
export { ForwardRef as ReactComponent };